module.exports = __webpack_public_path__ + "img/loading_b.af4df961.gif";